import { styled } from "styled-components"
import palette from "../../utils/colorPalette"

const Label = styled.div`
  font-size: 1rem;
  background-color: ${palette.button.default};
  border-radius: 10px;
  padding: 4px 8px;
  color: ${palette.buttonText.default};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  width: auto;
`

export default Label
